import { render, staticRenderFns } from "./samplelisting.vue?vue&type=template&id=38b6f457"
import script from "./samplelisting.vue?vue&type=script&lang=js"
export * from "./samplelisting.vue?vue&type=script&lang=js"
import style0 from "./samplelisting.vue?vue&type=style&index=0&id=38b6f457&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports